import CustomersPage from '@components/containers/b2b/CustomersPage';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

const B2bCustomers: FC = () => (
    <AppLayout>
        <CustomersPage />
    </AppLayout>
);

export default B2bCustomers;
